module.exports = __webpack_public_path__ + "media/fr_fr_s2_Dennise.fcc92697.oga";